module.exports = __webpack_public_path__ + "static/77gde-dbbb8fb0f00f7bce3589629f559e46ee.gif";